import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";
import { fmtWhen } from "@/components/ReviewBits";

export default function NotificationBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);
  const markAll = async () => { await api.post("/notifications/read", {}); load(); };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative w-9 h-9 rounded-full border border-[#E5E3DB] grid place-items-center text-[#4F5D4F] hover:text-[#0A3622] hover:border-[#0A3622] transition-colors" aria-label="Notifications" data-testid="notification-bell">
          <Bell size={16} weight={data.unread ? "fill" : "regular"} />
          {data.unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#C93B3B] text-white text-[10px] font-bold grid place-items-center" data-testid="notification-unread-count">{data.unread}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-white" data-testid="notification-panel">
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#E5E3DB]">
          <span className="text-sm font-semibold">Notifications</span>
          {data.unread > 0 && <button onClick={markAll} className="text-xs underline text-[#0A3622]" data-testid="notification-mark-all">Mark all read</button>}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 ? (
            <p className="text-sm text-[#4F5D4F] p-4" data-testid="notification-empty">No notifications yet.</p>
          ) : data.items.map((n) => (
            <Link key={n.id} to={n.link || "#"} onClick={() => api.post("/notifications/read", { ids: [n.id] }).then(load)}
              className={`block px-4 py-3 border-b border-[#F0EFEA] hover:bg-[#F9F7F4] ${n.read ? "" : "bg-[#FBF1DC]/40"}`} data-testid={`notification-${n.id}`}>
              <div className="text-sm font-medium text-[#132A13]">{n.title}</div>
              <div className="text-xs text-[#4F5D4F] mt-0.5">{n.body}</div>
              <div className="text-[10px] text-[#4F5D4F]/70 mt-1">{fmtWhen(n.created_at)}</div>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
